'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var base64$1 = require('./base64.js');

const {base64, base64pad, base64url, base64urlpad, __browser} = base64$1({
  encode: b => btoa(b.reduce((p, c) => p + String.fromCharCode(c), '')),
  decode: str => Uint8Array.from(atob(str), c => c.charCodeAt(0)),
  __browser: true
});

exports.__browser = __browser;
exports.base64 = base64;
exports.base64pad = base64pad;
exports.base64url = base64url;
exports.base64urlpad = base64urlpad;
